import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';
import RecommendGrid from './components/RecommendGrid';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryNav />
        <HotRanking />
        <LatestUpdates />
        <RecommendGrid />

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3">
              <i className="ri-shield-star-line text-accent-500 mr-2"></i>
              为什么选择汗汗漫画？
            </h2>
            <p className="text-sm text-foreground-500 mb-8 max-w-2xl mx-auto">
              汗汗漫画致力于提供最新最全的韩漫资源，全部支持免费在线观看，打造一个实时更新、覆盖无死角的韩漫大全内容库
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                { icon: 'ri-database-2-line', title: '海量资源', desc: '收录数千部热门韩漫作品，涵盖恋爱、奇幻、耽美、悬疑等多种类型' },
                { icon: 'ri-flashlight-line', title: '实时更新', desc: '最快速度同步更新，让你第一时间追到最新话，永不错过精彩内容' },
                { icon: 'ri-eye-line', title: '免费阅读', desc: '全部韩漫免费在线观看，无需注册付费，打开即看，畅享阅读乐趣' },
                { icon: 'ri-device-line', title: '多端适配', desc: '电脑、平板、手机完美适配，随时随地享受流畅的漫画阅读体验' },
              ].map((item, i) => (
                <div key={i} className="p-6 bg-background-50 rounded-lg text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                    <i className={`${item.icon} text-accent-600 text-xl`}></i>
                  </div>
                  <h3 className="font-semibold text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}